/**
 * Appends a page of items to an already-loaded list, skipping any whose key is
 * already present (or repeated within the page). Returns `prev` unchanged when
 * nothing new arrives.
 *
 * Infinite-scroll pages must go through this: S2's load-more sentinel can fire
 * `onLoadMore` repeatedly before React state commits, and a duplicated row key
 * sends React Aria's collection into an infinite loop that crashes the tab.
 */
export function appendUniqueBy<T>(
  prev: T[],
  next: T[],
  getKey: (item: T) => string | number,
): T[] {
  const seen = new Set(prev.map(getKey));
  const fresh: T[] = [];
  for (const item of next) {
    const key = getKey(item);
    if (seen.has(key)) continue;
    seen.add(key);
    fresh.push(item);
  }
  return fresh.length === 0 ? prev : [...prev, ...fresh];
}
